import { Box, TextInput, UnstyledButton } from '@mantine/core'
import clsx from 'clsx'
import { Loader2, Search, X } from 'lucide-react'

type Props = Pick<
    React.ComponentProps<'input'>,
    'onChange' | 'onFocus' | 'value'
> & {
    isLoading?: boolean
    onClear?: () => void
    onClose?: () => void
    onSearch: () => void
}

export const DesktopSearchBox = ({
    value,
    isLoading,
    onChange,
    onFocus,
    onClear,
    onSearch,
}: Props) => {
    return (
        <div className="bg-gray-50 w-full flex flex-row px-2 rounded-md ring items-center">
            <TextInput
                variant="unstyled"
                data-testid="desktop-search-bar-input"
                disabled={isLoading}
                onChange={onChange}
                onFocus={onFocus}
                placeholder="ex. Mario Kart DS..."
                className={clsx(
                    isLoading && 'pl-8',
                    'transition-all duration-200 ease-out flex-1',
                )}
                role="search"
                size="md"
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onSearch()
                    }
                }}
                value={value}
            />
            <div className="flex flex-row gap-2">
                {value && !isLoading && (
                    <span
                        data-testid="desktop-search-bar-clear-button"
                        onClick={onClear}
                        className="p-2 bg-gray-200 flex items-center rounded-md cursor-pointer hover:bg-gray-300"
                    >
                        <X className={'w-4 h-4'} />
                    </span>
                )}
                <span
                    onClick={onSearch}
                    className="p-2 bg-[var(--primary)] flex items-center rounded-md shadow cursor-pointer hover:bg-primary-dark"
                >
                    <Search size={18} className="text-white" />
                </span>
            </div>
            {/* <TextInput
                    data-testid="desktop-search-bar-input"
                    disabled={isLoading}
                    onChange={onChange}
                    onFocus={onFocus}
                    placeholder="ex. Mario Kart DS..."
                    styles={{
                        input: {
                            ':focus': {
                                border: `1px solid border-green-600`,
                            },
                        },
                    }}
                    className={clsx(
                        isLoading && 'pl-8',
                        'transition-all duration-200 ease-out flex-1',
                    )}
                    role="search"
                    size="md"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onSearch()
                        }
                    }}
                    value={value}
                    rightSection={
                        <div className="flex flex-row gap-2">
                            {value && !isLoading && (
                                <Button
                                    data-testid="desktop-search-bar-clear-button pr-4"
                                    onClick={onClear}
                                    className="flex items-center"
                                >
                                    <X className={'w-4 h-4'} />
                                </Button>
                            )}
                            <Button
                                size="sm"
                                radius="xs"
                                className="bg-[var(--primary)]"
                                onClick={onSearch}
                            >
                                <Search size={16} />
                            </Button>
                        </div>
                    }
                /> */}
        </div>
    )
}

export const MobileSearchBox = ({
    value,
    isLoading,
    onChange,
    onFocus,
    onClear,
    onSearch,
}: Props) => {
    return (
        <Box
            data-testid="mobile-search-bar"
            role="searchbox"
            className="relative w-full group"
        >
            {isLoading && (
                <Box className="absolute -translate-y-1/2 top-1/2 left-2">
                    <Loader2 className="w-4 h-4 text-primary animate-spin " />
                </Box>
            )}
            <form
                data-testid="mobile-search-bar-form"
                onSubmit={(e) => {
                    e.preventDefault()
                    onSearch()
                }}
            >
                <TextInput
                    icon={<Search className="w-4 h-4 text-primary" />}
                    data-testid="mobile-search-bar-input"
                    size="sm"
                    type="search"
                    disabled={isLoading}
                    onChange={onChange}
                    onFocus={onFocus}
                    placeholder="Rechercher..."
                    className={clsx(
                        isLoading && 'pl-8',
                        'transition-all duration-200 ease-out',
                    )}
                    role="search"
                    value={value}
                />
            </form>
            {value && !isLoading && (
                <UnstyledButton
                    data-testid="mobile-search-bar-clear-button"
                    onClick={onClear}
                    className="absolute flex items-center justify-center p-1 transition-all transform border rounded hover:bg-red-100 hover:text-red-600 bg-slate-100 max-h-max top-2 right-2"
                >
                    <X
                        className={clsx(
                            'w-4 h-4  transition-all',
                            isLoading
                                ? 'text-slate-400'
                                : 'text-slate-500 group-hover:text-slate-800',
                        )}
                    />
                </UnstyledButton>
            )}
        </Box>
    )
}
